import ResultDataCard from './resultDataCard.js';
export default ResultDataCard;
